module.exports = __webpack_public_path__ + "static/img/1.4789022.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/zh/1.png
// module id = U2Nj
// module chunks = 0